<template>
  <div class="form-group">
    <label class="form-label">Событие*</label>
    <CustomSelect name="event" @initialize="onEventSelectInitialize" @itemSelected="onEventSelectItemSelected">
      <option value="LeavingLife">Уход из жизни</option>
      <option value="FirstDisabilityGroup">Установление инвалидности I группы</option>
      <option value="SecondDisabilityGroup">Установление инвалидности II группы</option>
      <option value="TemporaryDisability">Временная нетрудоспособность</option>
    </CustomSelect>
  </div>

  <div class="form-group">
    <label class="form-label">Причина события*</label>
    <CustomSelect name="cause" @initialize="onEventCauseSelectInitialize" @itemSelected="onEventCauseSelectItemSelected">
      <option value="Accident">Несчастный случай</option>
      <option value="Disease">Болезнь</option>
      <option value="Other">Другое</option>
    </CustomSelect>
  </div>

  <div class="form-group">
    <label class="form-label">Что именно произошло (дополнительные комментарии к событию)</label>
    <textarea name="comments" class="form-textarea" rows="6" v-model="comments"></textarea>
  </div>

  <ContractInfoInsurer/>

</template>

<script>
import * as mns from '@/store/mutation-types';
import {mapGetters} from "vuex";
import ContractInfoInsurer from "@/components/insurances/shared/ContractInfoInsurer";
import CustomSelect from "@/components/utils/CustomSelect";

export default {
anotherNameLife: "LifeAndHealthInsurance",
  components: {ContractInfoInsurer, CustomSelect},
  methods: {
    onEventSelectInitialize(event){
      this.$store.commit(mns.SET_EVENT, event.getValue().value);
    },
    onEventSelectItemSelected(event){
      this.$store.commit(mns.SET_EVENT, event.detail.choice.value);
    },
    onEventCauseSelectInitialize(event){
      this.$store.commit(mns.SET_CAUSE, event.getValue().value);
    },
    onEventCauseSelectItemSelected(event){
      this.$store.commit(mns.SET_CAUSE, event.detail.choice.value);
    },
  },
  computed: {
    ...mapGetters(['event', 'cause', 'date']),
    comments: {
      get(){
        return this.$store.getters.comments;
      },
      set(value){
        this.$store.commit(mns.SET_COMMENTS, value);
      }
    }
  },
}
</script>

<style scoped>

</style>